var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { FETCH_ESHOP_HEADER_DATA_SUCCESS, IS_ESHOP_NAVANDSEARCH, FETCH_ESHOP_HEADER_DATA_ERROR, IS_NOT_CANOPY, SET_ESHOP_KW, LOAD_NOT_SELLER_ESHOP_HEADER, } from './actionTypes';
import { DataForEshopHeaderApiFactory } from '../services/eshop-header-api/codegenClient';
export const loadEshopHeaderData = (axiosInstance, eshopSellerLogin, basePath) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    if (eshopSellerLogin === '' || typeof eshopSellerLogin === 'undefined') {
        return;
    }
    return DataForEshopHeaderApiFactory(undefined, basePath, axiosInstance)
        .getEshopHeaderData(eshopSellerLogin)
        .then((result) => {
        const { data } = result;
        dispatch({
            type: FETCH_ESHOP_HEADER_DATA_SUCCESS,
            payload: data,
        });
    })
        .catch((err) => {
        dispatch({
            type: FETCH_ESHOP_HEADER_DATA_ERROR,
            payload: err.response ? { status: err.response.status, statusText: err.response.statusText } : err,
        });
    });
});
export const loadNotSellerEshopHeaderData = (eshopName, eshopLogoUrl, cashBack) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({
        type: LOAD_NOT_SELLER_ESHOP_HEADER,
        payload: {
            isEshopNavAndSearch: false,
            isNotCanopy: true,
            eshopName: eshopName,
            eshopLogoUrl: eshopLogoUrl || '',
            cashBack: cashBack,
            eshopBannerUrlMobile: process.env.ESHOP_BANNER_URL_MOBILE ||
                'https://fr.shopping.rakuten.com/images-eshop/ClubR_Banner_S.png',
            eshopBannerUrlDesktop: process.env.ESHOP_BANNER_URL_DESKTOP ||
                'https://fr.shopping.rakuten.com/images-eshop/ClubR_Banner_L.png',
            visibility: true,
            isCrew: true,
            isSeller: false,
        },
    });
});
export const isEshopNavAndSearch = (payload) => (dispatch) => {
    return dispatch({
        type: IS_ESHOP_NAVANDSEARCH,
        payload: { isEshopNavAndSearch: payload },
    });
};
export const isNotCanopyFn = (payload) => (dispatch) => {
    return dispatch({
        type: IS_NOT_CANOPY,
        payload: { isNotCanopy: payload },
    });
};
export const setKw = (payload) => (dispatch) => {
    return dispatch({
        type: SET_ESHOP_KW,
        payload: { kw: payload },
    });
};
